module.exports = __webpack_public_path__ + "static/media/wordsearch.07abed02.png";